import React from 'react';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Tooltip, Typography, Toolbar, Link, Button, Badge, TextField, InputAdornment } from '@material-ui/core';
import { Search as SearchIcon, Cancel as CancelIcon } from '@material-ui/icons';
import { EnhancedTableToolbarStyles } from './EnhancedTableToolbarStyles';
import Track from '../../../helpers/Analytics';

const EnhancedTableToolbar = props => {
  const { classes } = props;
  const { tooltip, numSelected, title, linkTo, linkText, onClear, showSearchField, metricNameFilter, onMetricNameFilterChanged } = props;
  return (
    <Toolbar className={classes.enhancedTableToolbarRoot}>
      <div className={classes.enhancedTableToolbar_TitleRow}>
        {title && (
          <Typography variant='h4' id='tableTitle' className={classes.enchancedTableToolbar_Title}>
            {title}
          </Typography>
        )}
        {numSelected && numSelected > 0 ? (
          <Typography color='inherit' variant='h6'>
            <Tooltip title={tooltip || ''}>
              <Link to={linkTo} component={RouterLink} className={classes.enhancedTableToolbarLinkButton}>
                <Badge color='error' badgeContent={numSelected} classes={{ badge: classes.enhancedTableToolbar_ButtonBadge }}>
                  <Button
                    variant='contained'
                    size='large'
                    className={clsx(classes.enchancedTableToolbar_Button, classes.enchancedTableToolbar_ChartButton)}
                    onClick={() => Track('Homepage', { id: 'Visualize-Click', url: linkTo })}
                  >
                    {linkText}
                  </Button>
                </Badge>
              </Link>
            </Tooltip>
            {numSelected > 0 ? (
              <Button
                variant='outlined'
                size='large'
                className={classes.enchancedTableToolbar_Button}
                onClick={() => {
                  Track('Homepage', { id: 'Deselect-Metrics' });
                  onClear();
                }}
              >
                {numSelected < 2 ? 'Deselect' : 'Deselect all'}
              </Button>
            ) : (
              <></>
            )}
          </Typography>
        ) : null}
      </div>
      <div className={classes.enhancedTableToolbarSpacer} />
      {showSearchField && (
        <div className={classes.enhancedTableToolbarActions}>
          <TextField
            id='search'
            className={classes.enhancedTableToolbarTextField}
            value={metricNameFilter}
            onChange={event => onMetricNameFilterChanged(event.target.value)}
            margin='normal'
            type='text'
            placeholder='Search available metrics'
            // variant="outlined"
            InputProps={{
              className: classes.input,
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position='start' className={classes.enhancedTableToolbarIcon}>
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position='end' className={classes.enhancedTableToolbarClearSearchButton}>
                  {metricNameFilter && metricNameFilter.length > 0 && (
                    <CancelIcon className={classes.enhancedTableToolbar_CancelIcon} fontSize='small' onClick={() => onMetricNameFilterChanged('')} />
                  )}
                </InputAdornment>
              )
            }}
          />
        </div>
      )}
    </Toolbar>
  );
};

export default withStyles(EnhancedTableToolbarStyles)(EnhancedTableToolbar);
